import React from "react";
import ConsumerHeader from "./ConsumerHeader";
import Header from "./Header";
import Footer from "./Footer";
import { readAudience } from "../utils/audience";

/**
 * Header and footer for pages that belong to neither side.
 *
 * Privacy Policy, Terms of Service and the 404 are reachable from both
 * experiences — the consumer consent checkbox on /ask links straight to two of
 * them — so hardcoding either nav puts the wrong one in front of half the
 * visitors. A consumer who clicks "Terms of Service" should not land on a page
 * offering Research Mode, Debate Mode and Start Free Trial.
 *
 * The side is taken from the audience the visitor chose at the splitter. With
 * no choice recorded (a direct link, a cleared browser) these pages fall back
 * to the attorney chrome, which is the wider product.
 *
 * Read once at mount rather than in a subscription: the choice only changes by
 * navigating through the splitter or a footer switch link, both of which
 * remount this anyway.
 */
function useAudience() {
  const [audience] = React.useState(() => readAudience());
  return audience === "consumer" ? "consumer" : "attorney";
}

export function AudienceHeader(props) {
  const audience = useAudience();
  return audience === "consumer" ? <ConsumerHeader {...props} /> : <Header {...props} />;
}

export function AudienceFooter(props) {
  const audience = useAudience();
  return <Footer {...props} audience={audience} />;
}
